// Data Download Limits
export const ORDERS_DOWNLOAD_LIMIT = 10000
export const TRANSACTIONS_DOWNLOAD_LIMIT = 10000
export const CUSTOMERS_DOWNLOAD_LIMIT = 10000
